import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the PersonalDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-personal-details',
  templateUrl: 'personal-details.html',
})
export class PersonalDetailsPage {
  bankInfo:any={};
  additionalData:any={};
  coApplicantsdata:any={};
  userName:any="";
  intrestRateType:any=""
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad PersonalDetailsPage',this.navParams.get('addressDetails'));
    this.navParams.get('addressDetails');
  }
  ionViewDidEnter() {
    console.log('ionViewDidLoad PersonalDetailsPage',this.navParams);
    this.ionSelected()
  }
  ionSelected(){
    

    this.bankInfo=this.navParams.data[5];
    //console.log("data",this.navParams.data[0])
    this.additionalData=this.navParams.data[0].filter((res:any)=>{
      return res.applicanttype=="Applicant"

    });
    this.coApplicantsdata=this.navParams.data[0].filter((res:any)=>{
      return res.applicanttype=="Co Applicant"

    })
    console.log(this.additionalData)
    this.additionalData=this.additionalData[0]
    this.coApplicantsdata=this.coApplicantsdata[0]
    this.userName=this.additionalData.customername;
    localStorage.setItem("name",this.userName)
    this.intrestRateType = this.navParams.data[1].interestratetype
    //console.log("Customer Name",this.additionalData);
     
  }

}



// WEBPACK FOOTER //
// ./src/pages/personal-details/personal-details.ts